/* beni homepage v2: play videos only while on screen, desktop arrows, slide counters, front / back switch.
   init(root) runs once on page load and again on any section the theme editor reloads
   (shopify:section:load), so settings changes show without refreshing the editor. */
(function () {
  if (window.__beniHome) return;
  window.__beniHome = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;
  if (!reduce && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && e.intersectionRatio > 0.35) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: [0, 0.35, 0.7] });
  }

  function each(root, sel, fn) {
    Array.prototype.forEach.call(root.querySelectorAll(sel), fn);
  }

  function init(root) {
    root = root || document;
    var desktop = window.matchMedia('(min-width: 750px)').matches;

    // drop the video meant for the other breakpoint before it loads
    each(root, '.bh video.bh-only-desktop, .bh video.bh-only-mobile', function (v) {
      var forDesktop = v.classList.contains('bh-only-desktop');
      if (forDesktop !== desktop) v.remove();
    });

    each(root, '.bh video[data-bh-play]', function (v) {
      if (v.getAttribute('data-bh-ready')) return;
      v.setAttribute('data-bh-ready', '1');
      // optional loop window, e.g. start 3s, end 10s
      var start = parseFloat(v.getAttribute('data-bh-start')) || 0;
      var end = parseFloat(v.getAttribute('data-bh-end')) || 0;
      if (start || end) {
        v.addEventListener('loadedmetadata', function () { if (start) v.currentTime = start; });
        v.addEventListener('timeupdate', function () {
          if ((end && v.currentTime >= end) || v.currentTime < start) v.currentTime = start;
        });
        v.addEventListener('ended', function () { v.currentTime = start; v.play().catch(function () {}); });
      }
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.loop = true;
      if (io) io.observe(v);
    });

    // desktop arrows on swipe rows that overflow; rows that fit get centred (.bh-track--fits)
    each(root, '.bh-track', function (track) {
      if (track.getAttribute('data-bh-arrows')) return;
      track.setAttribute('data-bh-arrows', '1');
      var box = document.createElement('div');
      box.className = 'bh-arrows';
      box.innerHTML = '<button type="button" aria-label="previous">&larr;</button><button type="button" aria-label="next">&rarr;</button>';
      var section = track.closest('.bh');
      var head = section && section.querySelector('.bh-head');
      if (head) { head.appendChild(box); } else { box.classList.add('bh-arrows--below'); track.parentNode.insertBefore(box, track.nextSibling); }
      var prev = box.children[0], next = box.children[1];
      function step() { var f = track.children[0]; return f ? f.getBoundingClientRect().width + 8 : 300; }
      function sync() {
        track.classList.remove('bh-track--fits');
        var max = track.scrollWidth - track.clientWidth - 2;
        track.classList.toggle('bh-track--fits', max <= 0);
        box.style.display = max > 0 ? '' : 'none';
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });

    // "1 / 6" counters on swipe galleries
    each(root, '[data-bh-count]', function (track) {
      if (track.getAttribute('data-bh-counted')) return;
      var out = document.getElementById(track.getAttribute('data-bh-count'));
      if (!out) return;
      track.setAttribute('data-bh-counted', '1');
      var total = track.children.length;
      function update() {
        var first = track.children[0];
        if (!first) return;
        var w = first.getBoundingClientRect().width + 8;
        var i = Math.min(total, Math.round(track.scrollLeft / w) + 1);
        out.textContent = i + ' / ' + total;
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      update();
    });

    // BENI CUSTOM (2026-10-10): front / back switch on phones (beni-feature, "Front / back switch")
    each(root, '[data-bh-fb]', function (box) {
      if (box.getAttribute('data-bh-ready')) return;
      box.setAttribute('data-bh-ready', '1');
      var imgs = box.querySelectorAll('.bh-fb__img');
      var btns = box.querySelectorAll('[data-bh-fb-i]');
      Array.prototype.forEach.call(btns, function (b) {
        b.addEventListener('click', function () {
          var i = parseInt(b.getAttribute('data-bh-fb-i'), 10);
          Array.prototype.forEach.call(imgs, function (im, j) { im.classList.toggle('is-on', j === i); });
          Array.prototype.forEach.call(btns, function (x, j) { x.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
